import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Icon } from '../../../../../../components/UI'
import JobsPost from './JobsPost'
import JobPostActivation from './JobPostActivation'
import JobPostPromote from './JobPostPromote'
import JobPostRenewal from './JobPostRenewal'
import JobPostActionSuccess from './JobPostActionSuccess'
import JobPostDeactivation from './JobPostDeactivation'
import JobPostCancelPromote from './JobPostCancelPromote'
import JobPostCancelRenewal from './JobPostCancelRenewal'
import TopUpModal from '../../../../../../components/Shared/TopUpModal'
import UsePagination from '../../../../../../components/pagination'
import JobPostModal from '../../../../JobPosts/JobPostModal'

import {
  getJob,
  getJobs,
  resetJob,
} from '../../../../../../routing/fetchingfunction/job/job.actions'
import { selectRole } from '../../../../../../routing/fetchingfunction/user/user.reducer'
import {
  selectJob,
  selectJobLoading,
  selectJobsLoading,
  selectJobsPagination,
} from '../../../../../../routing/fetchingfunction/job/job.reducer'

import { getPaginationTotalLength } from '../../../../../../helpers'

const JobsPosts = () => {
  const dispatch = useDispatch()

  const { jobs, jobsPage, jobsTotal, jobsPageSize } = useSelector(selectJobsPagination)
  const role = useSelector(selectRole)
  const loading = useSelector(selectJobsLoading)
  const job = useSelector(selectJob)
  const jobLoading = useSelector(selectJobLoading)

  const [jobPostId, setJobPostId] = useState(null)
  const [activateData, setActivateData] = useState(null)
  const [deactivateData, setDeactivateData] = useState(null)
  const [promoteData, setPromoteData] = useState(null)
  const [cancelPromoteData, setCancelPromoteData] = useState(null)
  const [renewalData, setRenewalData] = useState(null)
  const [cancelRenewalData, setCancelRenewalData] = useState(null)
  const [topUpCurrency, setTopUpCurrency] = useState(null)
  const [topUpSuccessData, setTopUpSuccessData] = useState(null)
  const [successData, setSuccessData] = useState({
    open: false,
    title: '',
    description: '',
  })

  const handleOpenActivate = (jobPost) => {
    setActivateData(jobPost)
  }

  const handleOpenDeactivate = (jobPost) => {
    setDeactivateData(jobPost)
  }

  const handleCloseActivate = () => {
    setActivateData(null)
  }

  const handleCloseDeactivate = () => {
    setDeactivateData(null)
  }

  const handleOpenPromote = (jobPost) => {
    setPromoteData(jobPost)
  }

  const handleOpenCancelPromote = (jobPost) => {
    setCancelPromoteData(jobPost)
  }

  const handleClosePromote = () => {
    setPromoteData(null)
  }

  const handleCloseCancelPromote = () => {
    setCancelPromoteData(null)
  }

  const handleOpenRenewal = (jobPost) => {
    setRenewalData(jobPost)
  }

  const handleOpenCancelRenewal = (jobPost) => {
    setCancelRenewalData(jobPost)
  }

  const handleCloseRenewal = () => {
    setRenewalData(null)
  }

  const handleCloseCancelRenewal = () => {
    setCancelRenewalData(null)
  }

  const handleOpenSuccess = (data) => {
    setSuccessData({
      open: true,
      ...data,
    })
  }

  const handleCloseSuccess = () => {
    setSuccessData((prevState) => {
      return {
        ...prevState,
        open: false,
      }
    })
  }

  const handleOpenTopUp = (currency) => {
    if (renewalData) {
      setTopUpSuccessData({
        type: 'renewal',
        data: renewalData,
      })

      setRenewalData(null)
    }

    if (promoteData) {
      setTopUpSuccessData({
        type: 'promote',
        data: promoteData,
      })

      setPromoteData(null)
    }

    if (topUpCurrency) {
      setTopUpCurrency(null)

      setTimeout(() => {
        setTopUpCurrency(currency)
      }, 0)

      return
    }

    setTopUpCurrency(currency)
  }

  const handleCloseTopUp = () => {
    setTopUpCurrency(null)
  }

  const handleContinueTopUp = () => {
    setTopUpCurrency(null)

    if (topUpSuccessData) {
      if (topUpSuccessData.type === 'renewal') {
        setRenewalData(topUpSuccessData.data)
      } else if (topUpSuccessData.type === 'promote') {
        setPromoteData(topUpSuccessData.data)
      }

      setTopUpSuccessData(null)
    }
  }

  const handleOpenJobPostDetails = (id) => {
    setJobPostId(id)
  }

  const handleCloseJobPostDetails = () => {
    setJobPostId(null)

    setTimeout(() => {
      dispatch(resetJob())
    }, 400)
  }

  const handlePageChange = (event, value) => {
    if (value !== jobsPage) {
      dispatch(
        getJobs({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    dispatch(
      getJobs({
        page: jobsPage || 1,
      })
    )
  }, [])

  useEffect(() => {
    if (jobPostId) {
      dispatch(getJob(jobPostId))
    }
  }, [jobPostId])

  const jobsContent = jobs.map((jobPost) => {
    return (
      <JobsPost
        key={jobPost.id}
        jobPost={jobPost}
        onDetails={handleOpenJobPostDetails}
        onActivate={handleOpenActivate}
        onDeactivate={handleOpenDeactivate}
        onPromote={handleOpenPromote}
        onCancelPromote={handleOpenCancelPromote}
        onRenewal={handleOpenRenewal}
        onCancelRenewal={handleOpenCancelRenewal}
      />
    )
  })

  return (
    <div className="w-full border-[#F79009] border-[1px] rounded-[10px] p-[20px] mt-[20px]">
      <div className="w-full flex items-center justify-between">
        <h5 className="text-base font-bold text-primary-100">Job Posts</h5>

        <Link
          to={`/${role}/settings/my-banners/jobs-posts/add`}
          className={`px-[16px] h-[40px] shadow-button bg-primary-button rounded-[8px] flex items-center transition-all duration-200 ease hover:bg-primary-button-hover`}
        >
          <Icon name="plus" color="#ffffff" className="mr-[8px] w-[24px] h-[24px]" />

          <span className="text-sm font-semibold text-white">Add New Job Post</span>
        </Link>
      </div>

      {!!jobs.length && (
        <div className="w-full flex flex-col gap-y-[10px] mt-[10px]">{jobsContent}</div>
      )}

      {jobsTotal > jobsPageSize && (
        <div className="mt-[20px]">
          <UsePagination
            count={getPaginationTotalLength(jobsTotal, jobsPageSize)}
            page={jobsPage}
            onChange={handlePageChange}
            loading={loading}
            altColors
          />
        </div>
      )}

      <JobPostModal
        isOpen={!!jobPostId}
        isLoading={jobLoading}
        job={job}
        onClose={handleCloseJobPostDetails}
      />

      <JobPostActivation
        jobPost={activateData}
        onClose={handleCloseActivate}
        onSuccess={handleOpenSuccess}
      />

      <JobPostDeactivation
        jobPost={deactivateData}
        onSubmit={handleCloseDeactivate}
        onClose={handleCloseDeactivate}
      />

      <JobPostPromote
        jobPost={promoteData}
        onTopUp={handleOpenTopUp}
        onClose={handleClosePromote}
        onSuccess={handleOpenSuccess}
      />

      <JobPostCancelPromote
        jobPost={cancelPromoteData}
        onSubmit={handleCloseCancelPromote}
        onClose={handleCloseCancelPromote}
      />

      <JobPostRenewal
        jobPost={renewalData}
        onTopUp={handleOpenTopUp}
        onClose={handleCloseRenewal}
        onSuccess={handleOpenSuccess}
      />

      <JobPostCancelRenewal
        jobPost={cancelRenewalData}
        onSubmit={handleCloseCancelRenewal}
        onClose={handleCloseCancelRenewal}
      />

      <JobPostActionSuccess successData={successData} onClose={handleCloseSuccess} />

      <TopUpModal
        currency={topUpCurrency}
        onClose={handleCloseTopUp}
        onContinue={handleContinueTopUp}
      />
    </div>
  )
}

export default JobsPosts
